import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';
import './ProjectRepAssigned.scss';
import { putRequest } from '../../requestUtils';

class ProjectRepAssigned extends Component {
  constructor(props) {
    super(props);
    this.state = {
      assignedRep: props.assignedRep,
    };

    this.handleSelectChange = this.handleSelectChange.bind(this);
    this.handleAssignRep = this.handleAssignRep.bind(this);
    this.handleDefaultAssignedRep = this.handleDefaultAssignedRep.bind(this);
  }

  componentDidMount() {
    this.handleDefaultAssignedRep();
  }

  handleAssignRep() {
    const { assignedRep } = this.state;
    const { csrfToken, project } = this.props;
    putRequest(
      `/projects/${project.resource_id}/`,
      { assigned_rep_id: assignedRep.value },
      csrfToken,
    ).catch(() => {
      this.setState({ assignedRep: {} });
    });
  }

  handleSelectChange(assignedRep) {
    this.setState({ assignedRep }, this.handleAssignRep);
  }

  handleDefaultAssignedRep() {
    const { assignedRep } = this.props;
    const defaultRep = assignedRep ? { value: assignedRep.id, label: assignedRep.name } : {};
    this.setState({ assignedRep: defaultRep });
  }

  render() {
    const { reps } = this.props;
    const { assignedRep } = this.state;
    return (
      <div>
        <div className="rep-assign form-group mb-8">
          <label htmlFor="project">
            <div className="body-text-2 medium-weight">
              Clora rep for project
            </div>
          </label>
          <Select
            id="clora rep"
            className="body-text-2"
            classNamePrefix="select-clora-rep"
            placeholder="Select or type..."
            options={reps.map((rep) => ({ value: rep.id, label: rep.name }))}
            value={assignedRep}
            onChange={(option) => {
              this.handleSelectChange(option);
            }}
          />
        </div>
      </div>

    );
  }
}

ProjectRepAssigned.propTypes = {
  reps: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  assignedRep: PropTypes.shape({}),
  csrfToken: PropTypes.string.isRequired,
  project: PropTypes.shape({}),
};

ProjectRepAssigned.defaultProps = {
  project: null,
  assignedRep: {},
};

export default ProjectRepAssigned;
